(function() {
    'use strict';

    angular
        .module('jmrsignApp')
        .controller('DocumentEventDeleteController',DocumentEventDeleteController);

    DocumentEventDeleteController.$inject = ['$uibModalInstance', 'entity', 'DocumentEvent'];

    function DocumentEventDeleteController($uibModalInstance, entity, DocumentEvent) {
        var vm = this;

        vm.documentEvent = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DocumentEvent.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
